import type {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
} from "firebase/firestore"

/**
 * Returns a Firestore converter that:
 *  - on read:  injects `oid: snapshot.id` so the document ID is part of the typed object
 *  - on write: strips `oid` so it is never stored as a field in Firestore
 */
export const makeConverter = <
  T extends { oid: string },
>(): FirestoreDataConverter<T> => ({
  toFirestore: ({ oid: _oid, ...data }: T) => data,
  fromFirestore: (snap: QueryDocumentSnapshot): T =>
    ({ oid: snap.id, ...snap.data() }) as T,
})
